<!--
 * @Author: ZhaoDong
 * @Date: 2022-10-24 18:57:01
 * @LastEditors: ZhaoDong
 * @LastEditTime: 2022-11-17 18:28:53
 * @Description: 基础信息
-->
<template>
  <a-form-model ref="ruleForm" labelAlign="right" :model="form" :rules="rules" :label-col="{ span: 4 }"
                :wrapper-col="{ span: 16 }">
    <!-- <h3 class="label_h3">基础信息</h3> -->
    <a-divider orientation="left">基础信息</a-divider>
    <a-row>
      <a-col :span="12">
        <a-form-model-item label="所属品牌" prop="project">
          <span>{{ projectName }}</span>
        </a-form-model-item>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="12">
        <a-form-model-item label="优惠券属性" prop="coupon_property">
          <a-select v-model="form.coupon_property" show-search option-filter-prop="children"
                    placeholder="请选择">
            <a-select-option v-for="(value, key ) in attributeList" :key="key" :value="key">
              {{ value }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="12">
        <a-form-model-item label="优惠券名称" prop="coupon_name">
          <a-input v-model.trim="form.coupon_name" allowClear placeholder="如： 新春有礼满100减20（不超过20字）" :maxLength="20"></a-input>
        </a-form-model-item>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="12">
        <a-form-model-item label="优惠券类型" prop="coupon_type">
          <a-radio-group v-model="form.coupon_type" :options="couponTypeOptions" @change="couponTypeChange"></a-radio-group>
        </a-form-model-item>
      </a-col>
    </a-row>
    <a-row v-if="form.coupon_type === '1'">
      <a-col :span="12">
        <a-form-model-item label="优惠面额" prop="coupon_amount">
          <div class="flex-ac">
            <a-input-number style="width:100%;" v-model="form.coupon_amount" allowClear placeholder="金额（如：20.00）"
                            :precision="2" :min="0.01" :max="10000000" />
            <span class="suffix" style="flex:1 0 auto;margin-left: 8px;">元</span>
          </div>
        </a-form-model-item>
      </a-col>
    </a-row>
    <a-row v-else>
      <a-col :span="12">
        <a-form-model-item label="优惠面额" prop="coupon_amount">
          <div class="flex-ac">
            <a-input-number style="width:100%;" v-model="form.coupon_amount" allowClear placeholder="折扣（如：8.8）"
                            :precision="1" :min="0.1" :max="9.9" />
            <span class="suffix" style="flex:1 0 auto;margin-left: 8px;">折</span>
          </div>
        </a-form-model-item>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="12">
        <a-form-model-item label="使用门槛" prop="coupon_threshold" ref="coupon_threshold">
          <a-radio-group v-model="thresholdType" @change="thresholdTypeChange">
            <div class="small-form-item">
              <a-radio :value="1">无门槛</a-radio>
            </div>
            <div class="small-form-item">
              <a-radio :value="2">
                有门槛，金额满
                <!-- <a-form-model-item prop="price" style="display: inline-block;margin-bottom: 0px;margin-top: -8px;"> -->
                <a-input-number v-if="thresholdType === 1" size="small" defaultValue="" style="width:120px;" allowClear disabled
                                placeholder="最低可用金额" :min="0" :max="10000000"/>
                <a-input-number v-else size="small" style="width:120px;" v-model="form.coupon_threshold" allowClear
                                placeholder="最低可用金额" :precision="2" :disabled="thresholdType !== 2" :min="0.01" :max="10000000"
                                @blur="() => { $refs.coupon_threshold.onFieldBlur() }" />
                <!-- </a-form-model-item> -->
                元可使用
              </a-radio>
            </div>
          </a-radio-group>
        </a-form-model-item>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="12">
        <a-form-model-item label="使用说明" prop="coupon_desc">
          <a-input type="textarea" v-model="form.coupon_desc" placeholder="说明（最多不超过50字，建议少于20字）"></a-input>
        </a-form-model-item>
      </a-col>
    </a-row>
  </a-form-model>
</template>

<script>
import { mapState } from "vuex"
import { pick } from 'lodash'

export default {
  props: {
    project: {
      type: [String, Number],
      default: () => ''
    },
    platformList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: {
        // project: undefined, // 品牌
        project: this.project, // 品牌
        coupon_property: undefined, // 优惠券属性 1.买家订单总价 2. 买家服务费券 3. 卖家服务费券'
        coupon_name: undefined, // 优惠券名称
        coupon_type: '1', // 优惠券类型 1.满减券 2.折扣券'
        coupon_amount: undefined, // 优惠面额
        // coupon_threshold: undefined, // 使用门槛
        coupon_threshold: '0', // 使用门槛
        coupon_desc: undefined // 使用说明
      },
      rules: {
        project: [{ required: true, message: '请选择所属品牌', trigger: ['change', 'blur'] }],
        coupon_property: [{ required: true, message: '请选择优惠券属性', trigger: ['change'] }],
        coupon_name: [{ required: true, message: '优惠券名称必填', trigger: ['blur'] }],
        coupon_type: [{ required: true, message: '请选择优惠券类型', trigger: ['change'] }],
        coupon_amount: [{ required: true, message: '优惠面额必填', trigger: ['blur'] }],
        // coupon_threshold: [{ required: true, message: '选择使用门槛', trigger: ['blur'] }]
        coupon_threshold: [{ required: true, validator: this.validThreshold, trigger: ['blur'] }],
        coupon_desc: [{ min: 0, max: 50, message: '最多不超过50字，建议少于20字', trigger: 'blur' }]
      },
      // attributeList: [], // 优惠券属性
      thresholdType: 1 // 使用门槛类别
    }
  },
  computed: {
    ...mapState({ labels: state => state.label.data }),
    // 品牌名
    projectName() {
      return this.platformList.find(item => +item.project === +this.project)?.name
    },
    // 优惠券属性
    attributeList() {
      return this.labels?.COUPON_ENUM?.COUPON_PROPERTY
    },
    couponTypeOptions() {
      const _data = this.labels?.COUPON_ENUM?.COUPON_TYPE
      return Object.entries(_data).map(([key, value]) => {
        return {
          label: value,
          // value: Number(key)
          value: String(key)
        }
      })
    }
  },
  methods: {
    validThreshold(rule, value, callback) {
      if (this.thresholdType === 2 && (value === undefined || value === '' || value === null)) {
        callback(new Error('门槛金额必填'))
        return
      }
      callback()
    },
    /**
     * 使用门槛切换
     */
    thresholdTypeChange() {
      if (this.thresholdType === 1) {
        // 无门槛： 使用门槛默认为0
        this.form.coupon_threshold = '0'
        // this.form.coupon_threshold = undefined
        this.$nextTick(() => {
          this.$refs.ruleForm.validateField(['coupon_threshold'])
        })
      } else {
        this.form.coupon_threshold = undefined
      }
    },
    couponTypeChange() {
      this.form.coupon_amount = undefined
    },
    changePlatform(e) { },
    async validate() {
      const valid = await this.$refs['ruleForm'].validate()
      return valid
    },
    async getValue(valid) {
      return new Promise((resolve, reject) => {
        if (valid) {
          this.$refs['ruleForm'].validate((valid) => {
            if (valid) {
              resolve({ ...this.form })
            } else {
              reject(new Error('valid fail'))
            }
          })
        } else {
          resolve({ ...this.form })
        }
      })
    },
    setValue(data) {
      const _formData = pick.apply(undefined, [data].concat(Object.keys(this.form)))
      this.form = _formData
      this.thresholdType = Number(_formData.coupon_threshold) !== 0 ? 2 : 1
    },
    resetForm() {
      this.$refs['ruleForm'].resetFields()
    }
  },
  components: {}
}
</script>

<style scoped lang="less">

</style>
